<template>
  <CockpitDialog
    title="人员定位报警列表"
    @close="closeAlarmList"
    :top="'200px'"
    :left="'400px'"
    :width="'1100px'"
    :height="'600px'"
  >
    <div class="w-full h-full relative">
      <div class="flex mb-20px mr-10px">
        <el-select
          v-model="searchForm.alarmType"
          size="small"
          class="mr-10px !w-50"
          placeholder="报警类型"
          clearable
          popper-class="visualization-select-popper"
        >
          <el-option
            v-for="item in alarmTypeList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchForm.handleState"
          size="small"
          class="mr-10px !w-50"
          placeholder="处理状态"
          clearable
          popper-class="visualization-select-popper"
        >
          <el-option
            v-for="item in stateList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px w-300px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchForm.alarmTime"
          popper-class="cockpit-picker-popper"
          clearable
        ></el-date-picker>
        <el-button size="small" type="primary" @click="searchList">查询</el-button>
        <el-button size="small" type="primary" @click="resetSearch">重置</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="w-full"
        height="calc(100% - 110px)"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="报警名称" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="报警类型"
          prop="alarmTypeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="报警对象"
          prop="personNames"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="报警状态"
          prop="alarmRemoveTypeStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="报警开始时间"
          prop="eventStartTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="报警结束时间"
          prop="eventEndTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="处理状态"
          prop="handleStateStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="处理意见"
          prop="handleAdvice"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <span
              class="cursor-pointer"
              @click="openHandleDialog(scope.row.id)"
              v-if="scope.row.handleState === 0"
              >处理</span
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="getAlarmList"
        :current-page.sync="page.pageNo"
        layout="prev, pager, next"
        :total="page.total"
        class="flex justify-center mt-20px ml-10px"
      ></el-pagination>
    </div>
    <CockpitDialog
      v-if="settingVisible"
      title="设置接收报警通知"
      @close="settingVisible = false"
      :top="'300px'"
      :left="'625px'"
      :width="'600px'"
      :height="'350px'"
    >
      <el-form :model="form" ref="formRef">
        <el-form-item
          label="处理意见"
          label-width="100px"
          prop="advice"
          :rules="[{ required: true, message: '请填写处理意见', trigger: ['change', 'blur'] }]"
        >
          <el-input
            v-model="form.advice"
            type="textarea"
            :rows="8"
            placeholder="请输入处理意见"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span class="flex justify-center">
        <el-button type="primary" @click="submitOpinion">
          保存
        </el-button>
        <el-button @click="settingVisible = false">取消</el-button>
      </span>
    </CockpitDialog>
  </CockpitDialog>
</template>

<script>
import dayjs from 'dayjs'
import { isEmpty, map, assign } from 'lodash'
import { StandardAlarmRecordApi } from '@wiz-api/personnel-position'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const alarmRecordApi = new StandardAlarmRecordApi()

export default {
  components: {
    CockpitDialog,
  },
  props: {
    alarmListVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchForm: {
        alarmType: '',
        handleState: '',
        alarmTime: ['', ''],
      },
      form: {
        advice: '',
      },
      tableData: [], // 报警列表
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      alarmTypeList: [
        {
          label: '越界进入',
          value: 0,
        },
        {
          label: '越界离开',
          value: 1,
        },
        {
          label: '超员',
          value: 2,
        },
        {
          label: '缺员',
          value: 3,
        },
        {
          label: '滞留',
          value: 4,
        },
        {
          label: '静止',
          value: 5,
        },
      ], // 报警类型下拉
      stateList: [
        {
          label: '待处理',
          value: 0,
        },
        {
          label: '已处理',
          value: 1,
        },
      ],
      settingVisible: false,
      currentId: '',
    }
  },
  created() {
    this.getAlarmList()
  },
  methods: {
    // 处理
    openHandleDialog(id) {
      this.settingVisible = true
      this.currentId = id
    },
    async submitOpinion() {
      await this.$refs.formRef.validate()
      const [err, res] = await alarmRecordApi.confirmAlarm(this.currentId, {
        advice: this.form.advice,
      })
      if (!err) {
        this.$message.success(this.$t('处理成功'))
        this.settingVisible = false
        this.getAlarmList()
      }
    },
    // 获取报警列表
    async getAlarmList() {
      this.tableLoading = true
      const [err, res] = await alarmRecordApi.getList({
        ...this.searchForm,
        startTime: isEmpty(this.searchForm.alarmTime) ? '' : this.searchForm.alarmTime[0],
        endTime: isEmpty(this.searchForm.alarmTime) ? '' : this.searchForm.alarmTime[1],
        sorting: '',
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      this.tableLoading = false
      if (!err) {
        this.tableData = this.getCheckList(res.items)
        this.page.total = res.totalCount
      }
    },
    // 初始化表格数据
    getCheckList(res) {
      return map(res, (item) => {
        return assign(item, {
          eventStartTime: item.eventStartTime
            ? dayjs(item.eventStartTime).format('YYYY-MM-DD HH:mm:ss')
            : '',
          eventEndTime: item.eventEndTime
            ? dayjs(item.eventEndTime).format('YYYY-MM-DD HH:mm:ss')
            : '',
          name: item.personNames + item.alarmTypeName + item.fenceName,
        })
      })
    },
    async searchList() {
      this.page.pageNo = 1
      await this.getAlarmList()
    },
    resetSearch() {
      this.searchForm = this.$options.data().searchForm
      this.searchList()
    },
    closeAlarmList() {
      this.$emit('update:alarmListVisible', false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/table';

::v-deep .el-textarea__inner {
  color: var(--cockpitInputFontColor) !important;
  background-color: var(--cockpitInputBgColor) !important;
  border: 1px solid !important;
  border-color: var(--cockpitInputBorderColor) !important;

  &:hover {
    border-color: var(--cockpitInputHoverBorderColor) !important;
  }
}

::v-deep .el-textarea .el-input__count {
  font-size: 12px;
  color: var(--cockpitInputNumberCreaseColor);
  background: var(--cockpitInputNumberCreaseBg);
  border: none;
}
</style>
